import React from 'react';
import { connect } from 'react-redux';
import * as effects from '../../common/effects';
import { CurrentLangButton } from '../atoms';
import { ListLang, MenuWithToggle } from '../organisms';
import { compose, lifecycle } from 'recompose';
import { selectUserData } from '../selectors';

const mapStateToProps = (state) => ({
  languages: selectUserData(state).languages,
});

const mapDispatchToProps = {
  setLanguages: effects.setLanguages,
  changeLanguage: effects.changeLanguage,
};

const enchance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.setLanguages();
    },
  })
);

const LangWidgetView = ({ languages, changeLanguage }) => {
  return (
    <MenuWithToggle
      button={(onClick) => <CurrentLangButton onClick={onClick} lang={languages.current} />}
      fade={true}
      render={() => <ListLang list={languages.list} onClick={changeLanguage} />}
    />
  );
};

export const LangWidget = enchance(LangWidgetView);
